import React from 'react';
import './advantage.component.sass';
import Advantage from "../../assets/image/SingleProduct-advantage.png";

const AdvantageComponent = () => {
    return (
        <div className='advantage-component'>
            <img src={Advantage} alt='xitonix advantage'/>
        </div>
    );
};

export default AdvantageComponent;